import { GOOGLE_MAPS_API_KEY } from "@ac-expo/utils";
import { Libraries, useJsApiLoader } from "@react-google-maps/api";
import { createContext, ReactNode, useContext } from "react";

type Props = {
  children: ReactNode;
};

type GoogleApiContextType = {
  isLoaded: boolean;
};

const defaultValue = {
  isLoaded: false,
};

const GoogleApiContext = createContext<GoogleApiContextType>(defaultValue);

export const useGoogleApiContext = () => {
  return useContext(GoogleApiContext);
};

const libraries = ["places"] satisfies Libraries;

export const GoogleApiProvider = ({ children }: Props) => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    id: "google-map-script",
    libraries,
    language: "fr",
  });

  return (
    <GoogleApiContext.Provider
      value={{
        isLoaded,
      }}
    >
      {children}
    </GoogleApiContext.Provider>
  );
};
